
import { Vue, Component } from 'nuxt-property-decorator'
import { WebPlayer } from '~/api'
import WebPlayerComponent from '~/components/WebPlayerComponent.vue'

@Component({
  components: { WebPlayerComponent },
  asyncData: async ({ route, $axios, error, redirect }) => {
    try {
      const versionId = route.params.versionId

      if (versionId === undefined) {
        return redirect('https://fabellacreator.com')
      }

      const res = await $axios.get(`v1/webplayer/${versionId}`)
      const data = res.data as WebPlayer

      return {
        platformSettings: data,
        embed: route.query.embed === 'true',
        versionId,
        ...(route.query.mmsi && /^\d{9}$/.test(route.query.mmsi as string) ? { mmsi: route.query.mmsi } : {mmsi: undefined}),
      }

    } catch (e: any) {
      let message = 'An error occurred'

      if (!e.response) {
        return error({ statusCode: 500, message })
      }

      switch (e.response.status) {
        case 403:
          message =
            'The web player is not activated! Please check your project settings.'
          break
        case 404:
          message = 'Project not Found'
          break
        case 500:
          message = 'Failed to load project'
          break
      }
      return error({ statusCode: e.response.status, message })
    }
  },
})
export default class Player extends Vue {
  platformSettings!: WebPlayer
  embed!: boolean
  versionId!: string

  // Check features and browser compatibility
  missingFeatures: string[] = []
  micSupported = true
  mmsi?: string

  mounted() {
    this.checkBrowserSupport()
  }

  head() {
    const title = this.platformSettings?.title
    let description = this.platformSettings?.subtitle

    if (!description) {
      description = 'Fabella Web Player'
    }

    const style = this.platformSettings
      ? `
      --background-color: ${this.platformSettings.layoutConfiguration.backgroundColor};
      --header-font-color: ${this.platformSettings.layoutConfiguration.headerFontColor};
    `
      : ``

    return {
      titleTemplate: title + ' - Fabella Web Player',
      bodyAttrs: {
        style,
      },
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: description,
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: title,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description,
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: this.platformSettings?.cover,
        },
        {
          hid: 'og:type',
          property: 'og:type',
          content: 'website',
        },
        {
          hid: 'twitter:card',
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title,
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: description,
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: this.platformSettings?.cover,
        },
      ],
    }
  }

  // Find if any required features are missing from the browser
  checkBrowserSupport() {
    // @ts-ignore
    const SRClass = window.SpeechRecognition || window.webkitSpeechRecognition
    if (!SRClass) {
      this.missingFeatures.push('Speech Recognition')
      this.micSupported = false
    }

    if (!navigator.geolocation) {
      this.missingFeatures.push('Geolocation')
    }
  }
}
